import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "p-d-flex p-flex-wrap"
}
const _hoisted_2 = { class: "p-d-flex p-flex-column p-mr-5 p-mb-4" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", { for: "search" }, "Nombre y apellido", -1)
const _hoisted_4 = {
  id: "search",
  class: "p-input-icon-right p-mt-2"
}
const _hoisted_5 = {
  class: "p-d-flex p-flex-column p-mr-5 p-mb-4",
  style: {"max-width":"300px"}
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { for: "coursePlans" }, "Cursos", -1)
const _hoisted_7 = {
  id: "coursePlans",
  class: "p-mt-2"
}
const _hoisted_8 = { class: "p-d-flex p-flex-column p-mb-4" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { for: "status" }, "Estado", -1)
const _hoisted_10 = {
  id: "status",
  class: "p-mt-2"
}
const _hoisted_11 = { class: "p-col-fixed" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingScreen = _resolveComponent("LoadingScreen")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_CoursePlanSelectorCustom = _resolveComponent("CoursePlanSelectorCustom")!
  const _component_OnboardingStatusSelector1 = _resolveComponent("OnboardingStatusSelector1")!
  const _component_Button = _resolveComponent("Button")!
  const _component_OnboardingTable = _resolveComponent("OnboardingTable")!
  const _component_Paginator = _resolveComponent("Paginator")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_LoadingScreen, { key: 0 }))
      : _createCommentVNode("", true),
    (!_ctx.isLoading && !_ctx.errorRef)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_InputText, {
                modelValue: _ctx.nameFilter,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.nameFilter = $event)),
                placeholder: "Nombre y apellido"
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_CoursePlanSelectorCustom, {
                coursePlans: _ctx.allCoursePlans,
                multipleSelection: true,
                modelValue: _ctx.coursesFilter,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.coursesFilter = $event)),
                onApplyFilter: _ctx.loadTracing
              }, null, 8, ["coursePlans", "modelValue", "onApplyFilter"])
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_OnboardingStatusSelector1, {
                modelValue: _ctx.stateFilter,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.stateFilter = $event))
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_Button, {
              type: "button",
              class: "p-text-left btn-custom-view",
              icon: "pi pi-chevron-down",
              iconPos: "right",
              label: 'Tabla',
              onClick: _ctx.toggle,
              "aria:haspopup": "true",
              "aria-controls": "overlay_panel_custom"
            }, null, 8, ["onClick"])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_OnboardingTable, {
      showCol: _ctx.showCol,
      staffTracing: _ctx.staffTracing,
      nameFilter: _ctx.nameFilter,
      stateFilter: _ctx.stateFilter,
      coursesFilter: _ctx.coursesFilter
    }, null, 8, ["showCol", "staffTracing", "nameFilter", "stateFilter", "coursesFilter"]),
    _createVNode(_component_Paginator, {
      onPage: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onPage($event))),
      rows: 10,
      totalRecords: (_ctx.staffTracing.nPages*10)
    }, null, 8, ["totalRecords"])
  ], 64))
}